export enum ApplicationCategory {
  NONE,
  OPERATION,
  DEVELOPMENT,
}
